import
  React
from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  ColorSvg,
  Text,
  VContainerH,
  VFillContainerVH
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../constants';

import {
  PrimaryButton
} from 'components';

import {
  withScreenViewTagging
} from 'hocs';

const Card = styled(VContainerH)`
  bottom: 58px;
  position: absolute;
  width: 344px;
  height: 324px;
  left: 50%;
  top: 284px;
  box-shadow: 0px 5px 15px 0px #00000026;
  transform: translate(-50%, -50%);
`;

export const ErrorCardUI = props => {

    ErrorCardUI.pageName = props.pageName;

    ErrorCardUI.tagViewData = {
    ...props.tagViewData
  };

  return (
    <>

      <Card
        backgroundColor={CustomColors.White}
        padding={props.padding}
        maxWidth={props.maxWidth}
        boxSizing={props.boxSizing}
        width={props.width}
        height={props.height} >

        <VFillContainerVH>

          <ColorSvg
            src={Icons.IconError}
            color={CustomColors.Red1}
            height={props.iconHeight}
            width={props.iconWidth}
            margin={props.iconMargin}/>

          {
            props.title &&
            <Text
              fontSize={props.titleFontSize}
                fontWeight={'bold'}
                margin={props.titleMargin}
              textAlign={'center'} >

              {props.title}
            </Text>
          }

          <VContainerH
            minHeight={'30%'} >

            <Text
                font-family={props.messageFontFamily}
                fontSize={props.messageFontSize}
                fontWeight={props.messageWeight}
                color={CustomColors.Grey9}
                textAlign={'center'}
                padding={'0px 16px'}
                whiteSpace={'pre-wrap'}>

                {props.message}
            </Text>
          </VContainerH>

          <PrimaryButton
            activeBackgroundColor={props.buttonColor}
            activeBorderColor={props.buttonColor}
            width={'100%'}
            maxWidth={'320px'}
            margin={'auto 0 32px'}
            text={props.buttonText}
            onClick={props.onClose}/>

        </VFillContainerVH>
      </Card>
    </>
  );
};

ErrorCardUI.propTypes = {
  padding: PropTypes.string,
  boxSizing: PropTypes.string,
  maxWidth: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  iconHeight: PropTypes.string,
  iconWidth: PropTypes.string,
  iconMargin: PropTypes.string,
  title: PropTypes.string,
  titleFontSize: PropTypes.string,
  message: PropTypes.string,
  messageFontFamily: PropTypes.string,
  messageWeight: PropTypes.string,
  messageFontSize: PropTypes.string,
  buttonText: PropTypes.string,
  buttonColor: PropTypes.string,
  pageSection: PropTypes.string,
  tagViewData: PropTypes.object,
  pageName: PropTypes.string.isRequired
};

ErrorCardUI.defaultProps = {
  boxSizing: 'border-box',
  width: '344px',
  height: '374px',
  iconHeight: '66px',
  iconWidth: '100px',
  iconMargin: '40px 0px 10px 0px',
  title: undefined,
  titleFontSize: '26px',
  titleMargin: '0px 0px 10px 0px',
  message: '',
  messageFontFamily: 'Roboto',
  messageWeight: 'normal',
  messageFontSize: '14px',
  buttonText: 'Okay',
  buttonColor: CustomColors.Red1,
  pageSection: 'emergency sms',
  tagViewData: {}
};

export const ErrorCard = withScreenViewTagging(ErrorCardUI);